import cst from './constellations.json';

const alphabet: any = {'alf':'α','alf01':'α¹','alf02':'α²',
          'bet':'β','bet01':'β¹','bet02':'β²','bet03':'β³',
          'gam':'γ','gam01':'γ¹','gam02':'γ²','gam03':'γ³',
          'del':'δ','del01':'δ¹','del02':'δ²','del03':'δ³',
          'eps':'ε','eps01':'ε¹','eps02':'ε²','eps03':'ε³',
          'zet':'ζ','zet01':'ζ¹','zet02':'ζ²','zet03':'ζ³',
          'eta':'η','eta01':'η¹','eta02':'η²','eta03':'η³',
          'the':'θ','the01':'θ¹','the02':'θ²','the03':'θ³',
          'tet':'θ','tet01':'θ¹','tet02':'θ²','tet03':'θ³',
          'iot':'ι','iot01':'ι¹','iot02':'ι²',
          'kap':'κ','kap01':'κ¹','kap02':'κ²',
          'lam':'λ','lam01':'λ¹','lam02':'λ²','lam03':'λ³',
          'mu.':'μ','mu.01':'μ¹','mu.02':'μ²','mu.03':'μ³',
          'nu.':'ν','nu.01':'ν¹','nu.02':'ν²','nu.03':'ν³',
          'ksi':'ξ','ksi01':'ξ¹','ksi02':'ξ²','ksi03':'ξ³',
          'omi':'ο','omi01':'ο¹','omi02':'ο²','omi03':'ο³',
          'pi.':'π','pi.01':'π¹','pi.02':'π²','pi.03':'π³','pi.04':'π⁴','pi.05':'π⁵','pi.06':'π⁶',
          'rho':'ρ','rho01':'ρ¹','rho02':'ρ²','rho03':'ρ³',
          'sig':'σ','sig01':'σ¹','sig02':'σ²','sig03':'σ³',
          'tau':'τ','tau01':'τ¹','tau02':'τ²','tau03':'τ³','tau04':'τ⁴','tau05':'τ⁵','tau06':'τ⁶','tau07':'τ⁷','tau08':'τ⁸','tau09':'τ⁹',
          'ups':'υ','ups01':'υ¹','ups02':'υ²','ups03':'υ³',
          'phi':'φ','phi01':'φ¹','phi02':'φ²','phi03':'φ³','phi04':'φ⁴',
          'chi':'χ','chi01':'χ¹','chi02':'χ²','chi03':'χ³',
          'psi':'ψ','psi01':'ψ¹','psi02':'ψ²','psi03':'ψ³','psi04':'ψ⁴','psi05':'ψ⁵','psi06':'ψ⁶','psi07':'ψ⁷','psi08':'ψ⁸','psi09':'ψ⁹',
          'ome':'ω','ome01':'ω¹','ome02':'ω²','ome03':'ω³'};
const greek: any = {'alf':'alpha',
'bet':'beta',
'gam':'gamma',
'del':'delta',
'eps':'epsilon',
'zet':'zeta',
'eta':'eta',
'the':'theta',
'tet':'theta',
'iot':'iota',
'kap':'kappa',
'lam':'lambda',
'mu.':'mu',
'nu.':'nu',
'ksi':'xi',
'omi':'omicron',
'pi.':'pi',
'rho':'rho',
'sig':'sigma',
'tau':'tau',
'ups':'upsilon',
'phi':'phi',
'chi':'chi',
'psi':'psi',
'ome':'omega'
};

function toTitleCase(str: string) {
    return str.replace(
      /\w\S*/g,
      function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
      }
    );
}

function getSimbadDescription(s: any) : string[] {
    let d: string[] = [];
    let co = getConstellationLookup();
    let name_bits: string[] = s.mainName.split(' ');
    if (alphabet.hasOwnProperty(name_bits[0])) {
        let gen = co[name_bits[1]];
        console.log('gen',name_bits[1],gen);
        let bits = [alphabet[name_bits[0]],'('+greek[name_bits[0]]+')',gen].concat(name_bits.slice(2));
        d.push(bits.join(' '));
        
        // bits = [greek[name_bits[0]], gen].concat(name_bits.slice(2));
        // d.push(bits.join(' '));
    }
    if (s.otherNamesJoin) {
        d.push(s.otherNamesJoin);
    }
    d.push(s.spectrum);
    d.push('('+(Math.round(s.glon * 100) / 100)+'°, '+(Math.round(s.glat * 100) / 100)+'°)');
    return d;
}

function getConstellationLookup(): any {
    let co: any = {};
    cst.forEach(item => {co[item.abbr] = item.genitive});
    return co;
}

export const handleSearchResponse = (d: any, g: any, update: any) => {
    // update state and UI using search response
    // stub for now
    let x = 0;
    let y = 0;
    let z = 0;
    let distance;
    let glon;
    let glat;
    let r = 0;
    let cosl, sinl, cosb, sinb;
    let plxSource = '';
    let errRatio = 0;
    let label = '';
    let description: string[] = [];
    let distanceFound = false;

    if (d.returnType === 'bj' || d.returnType === 'simbad_bj' || d.returnType === 'simbad' || d.returnType === 'other') {
        const bj = d.bj;
        if ((d.returnType === 'bj' || d.returnType === 'simbad_bj') && bj) {
            if (bj.rpgeo) {
                distance = parseFloat(bj.rpgeo);
            } else {
                distance = parseFloat(bj.rgeo);
            }

            distanceFound = true;

            glon = parseFloat(bj.glon);
            glat = parseFloat(bj.glat);

            cosl = Math.cos(glon*Math.PI/180);
            sinl = Math.sin(glon*Math.PI/180);
            cosb = Math.cos(glat*Math.PI/180);
            sinb = Math.sin(glat*Math.PI/180);
            x = distance*cosb*cosl;
            y = distance*cosb*sinl;
            z = distance*sinb;
            r = 0.5;
            plxSource = 'BJ';
            if (d.returnType === 'simbad_bj') {
                label = d.simbad.mainName;
                description = getSimbadDescription(d.simbad).concat([Math.round(distance).toString()+' pc (Bailer-Jones 2021)']);
            } else {
                label = 'Gaia EDR3 '+bj.source_id;
            }
        } else if (d.returnType === 'simbad_bj' || d.returnType === 'simbad') {
            const s = d.simbad;
            if (s) {   
                label = s.mainName;
                description = getSimbadDescription(d.simbad);             
                glon = parseFloat(s.glon);
                glat = parseFloat(s.glat);
                let parallax = s.parallax;
                if (parallax && parallax !== '~') {
                    distanceFound = true;
                    parallax = parseFloat(s.parallax);
                    distance = 1000/parallax;
                    cosl = Math.cos(glon*Math.PI/180);
                    sinl = Math.sin(glon*Math.PI/180);
                    cosb = Math.cos(glat*Math.PI/180);
                    sinb = Math.sin(glat*Math.PI/180);
                    x = distance*cosb*cosl;
                    y = distance*cosb*sinl;
                    z = distance*sinb;
                    r = 0.5;
                    plxSource = s.plxSource;
                    errRatio = parseFloat(s.errRatio);
                    description = getSimbadDescription(d.simbad).concat([Math.round(distance).toString()+' pc ('+plxSource+')']);
                }
            }
        } else if (d.returnType === 'other') {
            const data = d.data;
            distanceFound = true;
            x = parseFloat(data.x);
            y = parseFloat(data.y);
            z = parseFloat(data.z);
            r = parseFloat(data.r);
            label = toTitleCase(data.name);
        }
    }
    const temp_y = z;
    const temp_z = -y;
    y = temp_y;
    z = temp_z;
    r = 1.3*r;
    let searchVisible = distanceFound;
    let searchDone = !distanceFound;
    console.log('in handleSearchResponse',d,d.returnType,searchVisible,label,description,x,y,z,r);
    update((p: any) => ({ ...p, searchDone }));
    update((p: any) => ({ ...p, searchVisible }));
    update((p: any) => ({ ...p, x }));
    update((p: any) => ({ ...p, y }));
    update((p: any) => ({ ...p, z }));
    update((p: any) => ({ ...p, r }));
    update((p: any) => ({ ...p, label }));
    update((p: any) => ({ ...p, description }));
}